import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"
import routes from "./routes"
import { ToastContainer, Slide } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { SocketProvider } from "./contexts/SocketContext"
import { AuthProvider } from "./lib/useAuth"

function App() {
    return (
        <SocketProvider>
            <Router>
                <AuthProvider>
                    <div>
                        <ToastContainer
                            position="top-center"
                            autoClose={2000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={true}
                            draggable
                            transition={Slide}
                            theme="dark"
                        />
                    </div>
                    <Routes>
                        {routes.map((item, index) => (
                            <Route path={item.path} element={item.element} key={index} />
                        ))}
                    </Routes>
                </AuthProvider>
            </Router>
        </SocketProvider>
    )
}

export default App
